// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * ALMA Chatbot API
 * API to manage Alma chatbot interactions.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface MainUrlWithScore
 */
export interface MainUrlWithScore {
  /**
   *
   * @type {number}
   * @memberof MainUrlWithScore
   */
  score?: number;
  /**
   *
   * @type {string}
   * @memberof MainUrlWithScore
   */
  url?: string;
}

/**
 * Check if a given object implements the MainUrlWithScore interface.
 */
export function instanceOfMainUrlWithScore(
  value: object,
): value is MainUrlWithScore {
  return true;
}

export function MainUrlWithScoreFromJSON(json: any): MainUrlWithScore {
  return MainUrlWithScoreFromJSONTyped(json, false);
}

export function MainUrlWithScoreFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MainUrlWithScore {
  if (json == null) {
    return json;
  }
  return {
    score: json['score'] == null ? undefined : json['score'],
    url: json['url'] == null ? undefined : json['url'],
  };
}

export function MainUrlWithScoreToJSON(json: any): MainUrlWithScore {
  return MainUrlWithScoreToJSONTyped(json, false);
}

export function MainUrlWithScoreToJSONTyped(
  value?: MainUrlWithScore | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    score: value['score'],
    url: value['url'],
  };
}
